var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import cx from 'classnames';
import styles from './Toggle.module.scss';
import { Typography } from '../../foundations/typography';
/**
 * @tdr
 */
export var Toggle = forwardRef(function (_a, ref) {
    var _b = _a.wrapperProps, _c = _b === void 0 ? {} : _b, wrapperClassName = _c.className, wrapperRest = __rest(_c, ["className"]), className = _a.className, inputClassName = _a.inputClassName, showHide = _a.showHide, rest = __rest(_a, ["wrapperProps", "className", "inputClassName", "showHide"]);
    var classNames = cx(className, styles.toggle, wrapperClassName);
    var inputClassNames = cx(inputClassName, styles.input);
    return (React.createElement("span", __assign({ className: classNames }, wrapperRest),
        React.createElement("input", __assign({ className: inputClassNames, type: "checkbox", ref: ref }, rest)),
        !showHide ? (React.createElement(React.Fragment, null,
            React.createElement("span", { className: styles.handle }),
            React.createElement("span", { className: styles.track }))) : (React.createElement("div", { className: styles.showHideWrapper },
            React.createElement(Typography, { styleAs: "paragraphHeading", className: styles.showHide, noMargins: true }, "Show"),
            React.createElement(Typography, { styleAs: "paragraphHeading", className: styles.showHideInvert, noMargins: true }, "Hide")))));
});
//# sourceMappingURL=Toggle.js.map